import { cn } from '@/lib/utils';

export type StatusTone = 'emerald' | 'amber' | 'red' | 'blue' | 'slate';

const dotStyles: Record<StatusTone, string> = {
  emerald: 'bg-emerald-500',
  amber: 'bg-amber-500',
  red: 'bg-red-500',
  blue: 'bg-blue-500',
  slate: 'bg-slate-400',
};

interface StatusPillProps {
  label: string;
  tone?: StatusTone;
  dot?: boolean;
  pulse?: boolean;
  title?: string;
  className?: string;
}

export const StatusPill = ({
  label,
  tone = 'slate',
  dot = true,
  pulse = false,
  title,
  className,
}: StatusPillProps) => (
  <span
    title={title}
    className={cn(
      'inline-flex min-w-0 items-center gap-1.5 rounded-full bg-muted px-2 py-0.5 text-xs font-medium text-foreground/70 whitespace-nowrap',
      className,
    )}
  >
    {dot && (
      <span className="relative flex size-1.5 shrink-0">
        {pulse && (
          <span
            className={cn(
              'absolute inline-flex h-full w-full animate-ping rounded-full opacity-75',
              dotStyles[tone],
            )}
          />
        )}
        <span className={cn('relative inline-flex size-1.5 rounded-full', dotStyles[tone])} />
      </span>
    )}
    <span className="min-w-0 truncate">{label}</span>
  </span>
);
